import React, { FormEvent, useContext, useState, useEffect } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { processNodeDelete, processNodeFormSubmit, nodeDescription } from "./functions/workflow-sitemap-node-configuration";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import {
    Button
} from '@mui/material';

export const WorkflowSitemapNodeConfiguration = () => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog() {
        context.toggleShowSitemapModal(false);
    }

    const handleFormSubmit = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode() {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }

    const formSchema: RJSFSchema = {
        title: '',
        type: 'object',
        required: [],
        properties: {
            data_input: {
                'type': 'string',
                title: 'Data Input',
                'description': 'Location of URL to process?',
                default: 'default'
            },
            custom_key: {
                title: 'Custom Key',
                type: 'string',
                description: 'Value for Data Model or array keys, enter as value_one/value_two for nested values',
            },
            url_search: {
                title: 'URL Search',
                type: 'boolean',
                default: false,
                description: 'If there is no sitemap found, scrape the home page for URLs local to the supplied domain '
            },
            'data_management': {
                title: 'Data Store',
                type: 'string',
                description: 'Where to store any found data for next node',
                default: 'default'
            }
        },
    }


    const uiSchema: UiSchema = {
        'data_input': {
            'ui:widget': 'NodeDataManagementWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                ]
            }
        },
        'data_management': {
            'ui:widget': 'NodeDataManagementWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                ]
            },
        },
    }

    const widgets: RegistryWidgetsType = {
        NodeDataManagementWidget: NodeDataStoreSelectWidget
    }

    useEffect( () => {
        if (context.activeEditSitemapNode !== undefined && context.activeEditSitemapNode.data !== undefined) {
            setFormData(context.activeEditSitemapNode.data);
        }
    }, [context] );

    return (
        <DefaultFormDialog
            open={ context.showSitemapModal }
            title={ "Sitemap Parse Node" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditSitemapNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                id="workflow-sitemap-node-configure"
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>

                </div>
            </Form>
        </DefaultFormDialog>
    );

}